import React, { useState } from "react";

const faqs = [
    {
        question: "Who leads the Minterminds team?",
        answer: "Our team is led by Dinesh Kumar, the Founder & CEO of Minterminds IT Company.",
    },
    {
        question: "What kind of experts are in your team?",
        answer: "We have a talented team of developers, designers, UI/Ui Designer,  Product managers, Social Media Marketers, Frontend Developers, App developers, content Writers and engineers with diverse experience.",
    },
   
    {
        question: "Where is your team located?",
        answer: "Our core team is based in India, but we also work with remote talent globally.",
    },
    {
        question: "What technologies does your team specialize in?",
        answer: "Our team specializes in React, Node.js, Laravel, Flutter, MySQL, MongoDB, and other modern web and mobile technologies.",
    },
    {
        question: "Do you work with international clients?",
        answer: "Yes, we collaborate with clients globally and are experienced in handling projects from different time zones.",
    },
    {
        question: "How does your team ensure project quality?",
        answer: "We follow agile methodologies, conduct code reviews, automated testing, and regular client updates to ensure high-quality delivery.",
    },
    {
        question: "What industries do your team members have experience in?",
        answer: "Our team has worked across industries like logistics, e-commerce, food delivery, real estate, and SaaS platforms.",
    },
    {
        question: "Is your team available for long-term projects?",
        answer: "Yes, we are open to long-term partnerships and dedicated team models based on your project needs.",
    },
    {
        question: "Do you offer internships or training programs?",
        answer: "Yes, we periodically offer internships and mentorship opportunities for aspiring developers and designers.",
    },
];

const TeamFaq: React.FC = () => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const toggleAccordion = (index: number) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="max-w-4xl mx-auto px-4 py-16">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-[#333] mb-10">
                Frequently Asked Questions
            </h2>

            <div className="space-y-4">
                {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className="border border-[#ccc] rounded-lg overflow-hidden"
                    >
                        <button
                            onClick={() => toggleAccordion(index)}
                            className="w-full flex justify-between items-center p-4 text-left text-[#333] font-semibold bg-gray-50 hover:bg-gray-100 transition"
                        >
                            {faq.question}
                            <span className="ml-2 text-[#333]">
                                {activeIndex === index ? "−" : "+"}
                            </span>
                        </button>
                        <div
                            className={`transition-all duration-300 ease-in-out overflow-hidden px-4 text-gray-600 ${activeIndex === index ? "max-h-40 opacity-100 pb-4" : "max-h-0 opacity-0 pb-0"
                                }`}
                        >
                            <div className="py-2">
                                {faq.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TeamFaq;
